import "../../global.css";
import "./cashbackList.css";
import dayjs from "dayjs";
import CustomGrid from "../../components/grid/CustomGrid";
import { useEffect } from "react";
import { useState } from "react";
import { userRequest } from "../../requestMethods";
import IconButton from "@mui/material/IconButton";
import { DeleteOutline } from "@mui/icons-material";
import { useCompany } from "../../components/context/CompanyContext";
import Swal from "sweetalert2";
import Loading from "../../components/loading/loading";
import Button from "@mui/material/Button";
import SaveIcon from "@mui/icons-material/Save";
import { formatPricing } from "../../util/helper";
import { useDispatch, useSelector } from "react-redux";
import { titleSetRef } from "../../redux/titleRedux";
import Switch from "@mui/material/Switch";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import {
  buildCashbackApprovalPayload,
  cashbackApprovalRowId,
} from "../../util/cashbackApproval";

export default function CashbackList() {
  const [cashbacks, setCashbacks] = useState([{}]);
  const { companyId } = useCompany();
  const currentUser = useSelector((state) => state.user.currentUser);
  const [isLoading, setIsLoading] = useState(false);
  const [inputs, setInputs] = useState({});
  const [dateNow, setDateNow] = useState();
  const [cashback, setCashback] = useState();
  const [configRules, setConfigRules] = useState();
  const [cashbackCustomer, setCashbackCustomer] = useState([]);
  const [selectionModel1, setSelectionModel1] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(titleSetRef({ title: "Cashback" }));
    if (companyId > 0) {
      setDateNow(dayjs(new Date()).format("YYYY-MM-DD"));
      getCashback();
      getCompany();
      getCustomerCashback();
    }
  }, [companyId]);

  const getCompany = async () => {
    try {
      setIsLoading(true);
      const res = await userRequest.get(`${companyId}/company`);

      if (res.data && res.data.configRules) {
        setConfigRules(res.data.configRules);
        setCashback(res.data.configRules.cashback);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };
  const getCashback = async () => {
    try {
      const res = await userRequest.get(`${companyId}/cashback`);
      setCashbacks(res.data);
    } catch {
      console.log();
    }
  };
  const getCustomerCashback = async () => {
    try {
      const res = await userRequest.get(`${companyId}/cashback/toApproval`);
      setCashbackCustomer(res.data);
    } catch (error) {}
  };
  function validaCashback() {
    if (inputs.cashback === "" || inputs.cashback === undefined) {
      Swal.fire(
        "Atenção!",
        "O campo % Desconto deve ser preenchido.",
        "warning",
      );
      return false;
    }

    let cb = cashbacks.find((item) => item.deleted === null);
    if (cb) {
      Swal.fire(
        "Atenção!",
        "Você pode ter apenas 1 cashback ativo.",
        "warning",
      );
      return false;
    }

    // if (inputs.minValue && inputs.maxValue) {
    //   if (parseFloat(inputs.minValue) >= parseFloat(inputs.maxValue)) {
    //     Swal.fire(
    //       "Atenção!",
    //       "O campo Valor Mínimo deve ser menor que o campo Valor Máximo.",
    //       "warning"
    //     );
    //     return false;
    //   }
    // }

    if (inputs.expiryDays === undefined || inputs.expiryDays <= 0) {
      Swal.fire(
        "Atenção!",
        "O campo Dias para vencer deve ser maior que 0. ",
        "warning",
      );
      return false;
    }
    return true;
  }
  const addCashback = async () => {
    if (validaCashback()) {
      const res = await userRequest.post(`${companyId}/cashback`, {
        expiryDays: inputs.expiryDays,
        createdBy: currentUser.userId,
        companyId: companyId,
        percentCashback: inputs.cashback,
        minValue: parseFloat(inputs.minValue),
        maxValue: parseFloat(inputs.maxValue),
      });
      if (Object.keys(res.data).length > 0) {
        Swal.fire("Parabéns!", "Cashback criada com sucesso!", "success");
        getCashback();
      }
    }
  };
  const deleteCashback = async (cp) => {
    const res = await userRequest.put(`${companyId}/cashback/${cp}`, {
      deleted: dateNow,
      lastUserUpdate: currentUser.userId,
    });

    if (Object.keys(res.data).length > 0) {
      getCashback();
    } else {
      Swal.fire("Atenção!", "Erro ao excluir cashback!", "error");
    }
  };
  const deleteCashbackCustomer = async (cp) => {
    const res = await userRequest.put(
      `${companyId}/cashback/cashbackCustomer/${cp}`,
      {
        deleted: dateNow,
        lastUserUpdate: currentUser.userId,
      },
    );

    if (Object.keys(res.data).length > 0) {
      getCustomerCashback();
    } else {
      Swal.fire("Atenção!", "Erro ao excluir cashback cliente!", "error");
    }
  };
  const onButtonDeleteClick = async (e, row) => {
    if (currentUser.isAdmin) {
      Swal.fire({
        title: "Tem certeza que deseja excluir?",
        text: "Você não poderá reverter isso!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#EE8253",
        confirmButtonText: "Sim, excluir!",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          deleteCashback(row);
        }
      });
    } else {
      Swal.fire(
        "Atenção!",
        "Você não tem permissão para excluir o cashback!",
        "warning",
      );
    }
  };

  const onButtonDeleteCustomerClick = async (e, row) => {
    if (currentUser.isAdmin) {
      Swal.fire({
        title: "Tem certeza que deseja excluir?",
        text: "Você não poderá reverter isso!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#EE8253",
        confirmButtonText: "Sim, excluir!",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          deleteCashbackCustomer(row);
        }
      });
    } else {
      Swal.fire(
        "Atenção!",
        "Você não tem permissão para excluir o cashback!",
        "warning",
      );
    }
  };
  const handleChange = (e) => {
    setInputs((prev) => {
      return { ...prev, [e.target.name]: e.target.value };
    });
  };
  const Update = async (event) => {
    try {
      const res = await userRequest.put(`${companyId}/company/`, {
        configRules: configRules,
      });
    } catch (e) {}
  };
  const handleChangeDisableCashback = async (e) => {
    if (!e.target.checked) {
      if (currentUser.isAdmin) {
        Swal.fire({
          title: "Tem certeza que deseja desabilitar o Cashback?",
          text: "Todos cashback serão desativados e você não poderá reverter isso!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#EE8253",
          confirmButtonText: "Sim, excluir!",
          cancelButtonColor: "#d33",
          cancelButtonText: "Cancelar",
        }).then(async (result) => {
          if (result.isConfirmed) {
            setCashback(e.target.checked);
            configRules.cashback = false;
            deleteCashback("all");
            await Update();
          }
        });
      } else {
        Swal.fire(
          "Atenção!",
          "Você não tem permissão para desabilitar o cashback!",
          "warning",
        );
      }
    } else {
      setCashback(e.target.checked);
      configRules.cashback = true;
      await Update();
    }
  };

  const onButtonApprovalClick = async (e) => {
    const payload = buildCashbackApprovalPayload(selectionModel1);
    if (!payload.ok) {
      Swal.fire("Atenção!", payload.msg, "warning");
      return;
    }

    const res = await userRequest.post(`${companyId}/cashback/approval`, {
      cashbackIds: payload.cashbackIds,
    });

    if (res.data > 0) {
      setSelectionModel1([]);
      getCustomerCashback();
    } else {
      Swal.fire("Atenção!", "Erro ao aprovar cashback!", "error");
    }
  };
  const columns = [
    {
      field: "cashbackId",
      type: "number",
      align: "left",
      headerName: "Código",
      width: 100,
    },
    {
      field: "percentCashback",
      type: "number",
      align: "center",
      headerAlign: "center",
      headerName: "% Cashback",
      width: 150,
    },
    {
      field: "expiryDays",
      type: "number",
      align: "center",
      headerAlign: "center",
      headerName: "Dias vencimento",
      width: 150,
    },
    {
      field: "maxValue",
      type: "number",
      headerName: "% Máximo do pedido",
      width: 120,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "createdBy",
      type: "text",
      headerName: "Criado por",
      width: 150,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "createdAt",
      headerName: "Criada em",
      width: 150,
      align: "center",
      headerAlign: "center",
      type: "date",
      format: "dd/MM/yyyy HH:mm:ss",
    },
    {
      field: "deleted",
      headerName: "Inativado",
      width: 150,
      align: "center",
      headerAlign: "center",
      type: "date",
      format: "dd/MM/yyyy HH:mm:ss",
    },
    {
      field: "deletar",
      type: "text",
      headerName: "",
      width: 80,
      align: "center",
      headerAlign: "center",
      headerClassName: "dataGridMuiHeader",
      display: "flex",
      renderCell: (params) => {
        if (!params.row.deleted) {
          return (
            <IconButton
              onClick={(e) => onButtonDeleteClick(e, params.row.cashbackId)}
            >
              <DeleteOutline />
            </IconButton>
          );
        }
      },
    },
  ];
  const columnsCashback = [
    {
      field: "cashbackId",
      type: "number",
      align: "left",
      headerName: "Código",
      width: 100,
    },
    {
      field: "name",
      type: "text",
      headerName: "Nome",
      width: 200,
      align: "left",
    },
    {
      field: "contact",
      type: "text",
      headerName: "Contato",
      width: 200,
      align: "left",
    },
    {
      field: "amount",
      type: "number",
      headerName: "Total",
      width: 200,
      align: "left",
      format: "BRL",
    },
    {
      field: "expiryDate",
      headerName: "Data Vencimento",
      width: 200,
      align: "left",
      type: "date",
      format: "dd/MM/yyyy HH:mm:ss",
    },

    {
      field: "managedName",
      type: "text",
      headerName: "Vendedor(a)",
      headerClassName: "dataGridMuiHeader",
      width: 200,
      align: "left",
    },
    {
      field: "deletar",
      type: "text",
      headerName: "",
      width: 80,
      align: "center",
      headerAlign: "center",
      headerClassName: "dataGridMuiHeader",
      display: "flex",
      renderCell: (params) => {
        if (!params.row.deleted) {
          return (
            <IconButton
              onClick={(e) =>
                onButtonDeleteCustomerClick(e, params.row.cashbackId)
              }
            >
              <DeleteOutline />
            </IconButton>
          );
        }
      },
    },
  ];
  return (
    <div className="cust-page">
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <div className="cust-title">Cashback</div>

          {/* Novo cashback */}
          <div className="cust-card">
            <div className="cust-section-header">
              <div className="cust-switch-row">
                <Switch
                  defaultChecked={cashback}
                  inputProps={{ "aria-label": "controlled" }}
                  onChange={(e) => handleChangeDisableCashback(e)}
                />
                Cashback {cashback ? "Habilitado" : "Desabilitado"}
              </div>
            </div>
            <div className="cust-fields cust-fields-3">
              <div className="cust-field">
                <label className="cust-label">% Cashback</label>
                <input
                  className="cust-input"
                  type="number"
                  name="cashback"
                  onChange={handleChange}
                  maxLength="100"
                  disabled={!cashback}
                />
              </div>
              <div className="cust-field">
                <label className="cust-label">Dias para vencer</label>
                <input
                  className="cust-input"
                  type="number"
                  name="expiryDays"
                  onChange={handleChange}
                  maxLength="100"
                  disabled={!cashback}
                />
              </div>
              <div className="cust-field">
                <label className="cust-label">% Máximo do pedido</label>
                <input
                  className="cust-input"
                  type="number"
                  name="maxValue"
                  onChange={handleChange}
                  maxLength="100"
                  disabled={!cashback}
                />
              </div>
            </div>
            <div style={{ padding: "0 16px 16px" }}>
              <Button
                variant="contained"
                color="secondary"
                size="small"
                startIcon={<SaveIcon />}
                onClick={addCashback}
                disabled={!cashback}
              >
                Adicionar Cashback
              </Button>
            </div>
          </div>

          {/* Lista cashbacks */}
          <div className="cust-card">
            <div className="cust-section-header">Cashbacks Cadastrados</div>
            <div style={{ padding: "16px" }}>
              <CustomGrid
                gridId="cashList"
                rows={cashbacks}
                columns={columns}
                pageSize={45}
                checkboxSelection={false}
              />
            </div>
          </div>

          {/* Liberação cashbacks */}
          <div className="cust-card">
            <div className="cust-section-header">Liberação Cashbacks</div>
            <div style={{ padding: "16px" }}>
              <div style={{ padding: "16px" }}>
                <CustomGrid
                  gridId="liebracaCashList"
                  rows={cashbackCustomer}
                  columns={columnsCashback}
                  pageSize={45}
                  getRowId={cashbackApprovalRowId}
                  checkboxSelection
                  selectionModel={selectionModel1}
                  onSelectionChange={(ids) => setSelectionModel1(ids)}
                />
              </div>
            </div>
            <div style={{ padding: "0 16px 16px" }}>
              <Button
                variant="contained"
                color="secondary"
                startIcon={<SaveIcon />}
                onClick={onButtonApprovalClick}
                disabled={!selectionModel1.length}
                size="small"
              >
                Aprovar
              </Button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
